export const BILLING_CONTRACT_APPLIED_ON_TYPES = {
  MEDIA_COST: 'billing_fee_media_cost',
  INVESTMENT: 'billing_fee_investment',
} as const;
export type BILLING_CONTRACT_APPLIED_ON_TYPES =
  (typeof BILLING_CONTRACT_APPLIED_ON_TYPES)[keyof typeof BILLING_CONTRACT_APPLIED_ON_TYPES];
